<template>
  <div class="wrapper-main">
    <div class="banner-box">
      <div class="desc">
        <div class="title">
          <img :src="logo" class="logo" />
          昆明澳滇科技有限公司
        </div>
        <div class="content">昆明澳滇科技有限公司成立于2014年，位于昆明理工大学科技园，以海归人员为主依托于昆明理工大学从事产学研一体化的产品转化工作。目前公司主要从事医疗和教育行业相关的信息化产品的研究、开发和应用推广工作，也从事其它行业的信息技术开发和计算机系统集成工作。</div>
        <div class="content">公司具有较强的产品研究与设计开发能力。产品主要涉及医疗管理信息化，医疗信息融合与大数据采集和挖掘，医学成像仿真与图像处理分析；智慧校园和素质教育信息技术，人工智能和计算机技术应用。公司也为在校本科生和研究生在医院和学校的实践创造机会，培养学生参与企事业的项目设计和开发能力，解决行业内存在的问题。</div>
        <div class="content right">邮箱：120112624@qq.com</div>
      </div>
    </div>
    <h1>自主研发产品介绍</h1>
    <div class="row"></div>
    <div class="list">
      <div v-for="(item,index) in productList" class="product" :key="index">
        <img :src="item.icon" class="icon" @click="onClick(item)">
        <div class="info" v-if="item.title">
            <div class="title" @click="onClick(item)">{{item.title}}</div>
            <!-- <div class="desc">{{item.desc}}</div> -->
            <div class="desc" v-html="item.desc"></div>
        </div>
      </div>
    </div>
    <BackTop />
  </div>
</template>

<script>
import BackTop from "@/components/BackTop.vue";
import sjjh from '@/assets/sjjh.png'
import lnb from '@/assets/lnb.png'
import sbwx from '@/assets/sbwx.png'
import ncz2 from '@/assets/ncz2.png'
import zl from '@/assets/zl.png'
import sb from '@/assets/sb.png'
import xmsb from '@/assets/xmsb.png'
import xy from '@/assets/xy.png'
import wd from '@/assets/wd.png'
import sbgl from '@/assets/sbgl.png'
import pacs from '@/assets/pacs.png'
import hy from '@/assets/hy.png'
import hcgl from '@/assets/hcgl.png'
import snzk from '@/assets/snzk.png'
import ydcx from '@/assets/ydcx.png'
import logo from '@/assets/logo.png'
import zcpd from '@/assets/zcpd.png'
import ds from '@/assets/ds.png'
import yc from '@/assets/yc.png'
import sx from '@/assets/sx.png'
import cy from '@/assets/cy.png'
import f from '@/assets/f.png'
import gjyl from '@/assets/gjyl.png'
import ycyx from '@/assets/ycyx.png'
import xljk from '@/assets/xljk.png'
import zytz from '@/assets/zytz.png'
import myjk from '@/assets/myjk.png'
import jhy from '@/assets/jhy.png'

export default {
  name: "about",
  components: {
    BackTop
  },
  data() {
    return {
      logo,
      productList: [
        {
          icon: cy,
          title: '澳滇彩云大健康云平台',
          url: 'https://www.km-aodian.com/health-web',
          desc: "<span style='font-weight: 700;'>简介：</span>基于居民健康档案信息，构建大健康产业生态链融合。采用智能终“端”设备检测居民健康状态信息并自动上传到云端服务器进行存储计算管理，居民签约家庭医生或健康管理师基于居民健康信息进行个性化精准服务。可将大健康产业划分的医疗、医药、保健品、健康管理服务、健康养老服务，等五大领域链接融合在一起，提供对居民健康全生命周期的管理服务。"
        },
        {
          icon: f,
          title: 'VTE临床防治诊疗管控综合信息化平台',
          url: 'https://www.km-aodian.com/health-web',
          desc: "<span style='font-weight: 700;'>简介：</span>静脉血栓栓塞症VTE（肺栓塞PE和深静脉血栓形成DVT）已构成医疗质量和安全的潜在风险，成为临床医务人员和医院管理者面临的严峻问题。临床上诸多科室的患者均存在VTE风险；其发病隐匿、临床症状不典型，容易误诊、漏诊，一旦发生，致死和致残率高。而VTE又是一种可预防的疾病，积极有效的预防可以显著降低其发生率；规范诊断与治疗可以显著降低其病死率。目前急需加强VTE医院内综合防治，开展VTE信息化建设是按照指南规范预防诊疗提高医院质控工作的基础。国家已经把V TE纳入《三级医院评审标准（2020）版》考核指标。为此，公司团队根据国家VTE预防诊疗指南要求，再结合医院临床需求设计并研发了一套VTE临床防治诊疗管控综合信息化平台，实现从VTE（DVT-PE）风险人群识别与预防到DVT-PE-CTEPH综合诊治和质量控制的全套智能化解决方案，为医院申请加入全国VTE防治联盟或VTE优秀示范单位，以及医院等级评审创造条件。"
        },
        {
          icon: sx,
          title: '腮腺瘤超声AI检测',
          url: 'http://huyangsheng.cn/parotid/#/',
          desc: "<span style='font-weight: 700;'>简介：</span>腮腺肿瘤是最常见的唾液腺肿瘤之一，其病理状态复杂。其中大约75%的腮腺肿瘤属于良性肿瘤，但如果治疗决策和诊断不及时，良性肿瘤有可能复发或转化为恶性。因此，对该肿瘤的准确鉴别显得尤为重要。在此，我们采用深度学习模型对腮腺肿瘤的超声图像进行训练，旨在通过肿瘤的超声图像对其的良恶性进行准确判断，便于对其制订有效的治疗方案和进行后续治疗。"
        },
        {
          icon: lnb,
          title: "云南省老年健康综合评测系统平台",
          url: "http://111.229.189.175:7071",
          desc: "<span style='font-weight: 700;'>简介：</span>为“健康云南”打造的综合化健康数字平台，是对接医、养、康各机构筛查老年健康综合征的有效手段，用多学科方法对老年人的疾病、体能、认知、心理和社会等层面进行临床测试，将整个过程实现电子化管理，以便进行相关的统计分析，得到有价值的信息。并据此制订以维持和改善老年人健康及功能状态为目的的治疗计划。目前已有省内外100多家医疗卫生机构加入平台共享数据开展工作。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span>①共50个量表评估及时发现患者潜在的功能缺陷；②明确患者的医疗和护理需求；③制定可行的治疗干预策略；④随访疗效和调整治疗计划；⑤安排患者合理使用慢性长期的医疗和护理服务。"
        },
        // {
        //   icon: lnb,
        //   title: "云南省老年健康综合评测系统平台简易测评",
        //   url: "http://111.229.189.175:7070/jycp",
        //   desc: "<span style='font-weight: 700;'>简介：</span>为“健康云南“打造的综合化健康数字平台，是对接医、养、康各机构筛查老年健康综合征的有效手段，用多学科方法对老年人的疾病、体能、认知、心理和社会等层面进行临床测试，将整个过程实现电子化管理，以便进行相关的统计分析，得到有价值的信息。并据此制订以维持和改善老年人健康及功能状态为目的的治疗计划。目前已有省内外30多家医疗卫生机构加入平台共享数据开展工作。<br/>" + 
        //   "<span style='font-weight: 700;'>功能描述：</span>①共8个量表评估及时发现患者潜在的功能缺陷；②明确患者的医疗和护理需求；③制定可行的治疗干预策略；④随访疗效和调整治疗计划；⑤安排患者合理使用慢性长期的医疗和护理服务。"
        // },
        // {
        //   icon: lnb,
        //   title: "云南省老年健康综合评测系统平台住院版",
        //   url: "http://111.229.189.175:7070/zyb",
        //   desc: "<span style='font-weight: 700;'>简介：</span>为“健康云南“打造的综合化健康数字平台，是对接医、养、康各机构筛查老年健康综合征的有效手段，用多学科方法对老年人的疾病、体能、认知、心理和社会等层面进行临床测试，将整个过程实现电子化管理，以便进行相关的统计分析，得到有价值的信息。并据此制订以维持和改善老年人健康及功能状态为目的的治疗计划。目前已有省内外30多家医疗卫生机构加入平台共享数据开展工作。<br/>" + 
        //   "<span style='font-weight: 700;'>功能描述：</span>①共39个量表评估及时发现患者潜在的功能缺陷；②明确患者的医疗和护理需求；③制定可行的治疗干预策略；④随访疗效和调整治疗计划；⑤安排患者合理使用慢性长期的医疗和护理服务。"
        // },
        {
          icon: lnb,
          title: "云南省老年健康综合评测系统平台养老院版",
          url: "http://111.229.189.175:7070/yly",
          desc: "<span style='font-weight: 700;'>简介：</span>是筛查老年综合征的有效手段，用多学科方法对老年人的疾病、体能、认知、心理和社会等层面进行临床测试，将整个过程实现电子化管理，以便进行相关的统计分析，得到有价值的信息。并据此制订以维持和改善老年人健康及功能状态为目的的治疗计划。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span>①共22个量表评估及时发现患者潜在的功能缺陷；②明确患者的医疗和护理需求；③制定可行的治疗干预策略；④随访疗效和调整治疗计划；⑤安排患者合理使用慢性长期的医疗和护理服务。"
        },
        {
          icon: ncz2,
          title: "云南省脑卒中综合信息管理系统",
          url: "http://111.229.189.175:7081/sims",
          desc: "<span style='font-weight: 700;'>简介：</span>脑卒中（中风）疾病致残和致死风险很高，会对家庭和社会造成很大负担。临床需要大量采集脑卒中患者数据进行分析，然后研究制定出疾病的预防和诊疗方案。我们研究设计了具有中心特色的脑卒中平台系统，它基于互联网+脑卒中的区域大数据采集开放平台，各医疗机构均可加入平台共享数据。该平台系统是参照《中国卒中中心建设指南》的要求，自动采集医院内EMR、LIS、HIS和PACS等系统上脑卒中患者的核心数据，实现数据的统计分析，可用于临床的教学和科研。此系统目前在全省推广应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：</span><br/>1）脑卒中患者的数据自动上传到系统并进行集中化管理<br/>" + 
          "2）实时掌握脑卒中患者的各项数据情况<br/>" + 
          "3）科研平台数据的搭建，从而进行智能数据分析和数据挖掘<br/>" + 
          "4）各医院之间脑卒中患者的数据共享，充分利用健康大数据服务于患者<br/>" + 
          "5）用脑卒中评分量表对患者进行实时测评分析<br/>" + 
          "6）支持移动智能终端设备实时访问<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
         "1) 量表：提供快捷操作不同量表的入口，包含21个评分量表的新增及查询入口。<br/>" + 
          "2) 患者：根据患者操作不同量表，能快速的填写多个量表，不用重复录入患者基本信息。<br/>" + 
          "3) 我的：对操作系统人员进行绑定，方便下次无重新登录直接使用，可以修改登录密码。<br/>" + 
          "4）统计分析：对系统中的评分量表统计分析，统计评分中病例的画像情况，统计病例增长的情况。<br/>"
        },
        {
          icon: zl,
          title: "云南省肿瘤患者信息管理系统",
          url: "http://111.229.189.175:7070/zl",
          desc: "<span style='font-weight: 700;'>简介：</span>肿瘤是人类的第一大杀手，对个人健康和社会危害极大。临床医务工作者对肿瘤的诊疗需要大量采集肿瘤患者数据进行分析，然后研究制定出疾病的预防和诊疗方案。我们研究设计了具有中心特色的肿瘤数据采集管理平台，它基于互联网+肿瘤的区域大数据采集开放平台，各医疗机构均可加入平台共享数据。可以自动从医院的信息化系统中采集信息，它包括患者的基本信息、既往史、个人史、婚姻史、月经及生育史、家族史、病例特点、体格检查、出院情况、住院费用、病理报告、药物毒性分析、实验室检查、病毒感染类型、心电图、影像学检查、胸腔积液、腹腔积液、心包积液、脑积液、内镜、全身化疗、局部化疗、靶向治疗、放疗治疗、介入治疗、免疫治疗、姑息治疗、可评估病灶大小、基因诊断、PICC放置、疗效评价、转归、生存期、随访等共计576项指标。此系统目前在全省推广应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：</span><br/>" + 
          "1）患者的数据自动采集并保存<br/>" + 
          "2）支持移动智能终端设备实时访问患者的各项数据情况<br/>" + 
          "3）作为科研平台积累数据进行大数据分析统计<br/>" + 
          "4）加入系统的医院可以实现数据共享实现学科联盟<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" + 
          "1) 基础数据管理：基础数据模块管理分为省份信息、中心信息和单位信息。<br/>" + 
          "2) 病例管理：将患者相关的576项指标从医院的信息化系统中自动采集并保存到可以平台上。<br/>" + 
          "3) 用户管理：定义用户的权限和角色以保障平台系统的安全。<br/>" + 
          "4）统计分析：对患者的数据进行大数据统计分析。<br/>"
        },
        {
          icon: sb,
          title: "云南省肾病综合管理平台系统",
          url: "http://111.229.189.175:7078",
          desc: "<span style='font-weight: 700;'>简介：</span>目前肾病患者逐年增加。临床医务工作者迫切需要一个患者数据采集平台收集患者的大量相关信息用于诊疗。我们设计并实现了具有中心特色的肾病数据采集管理平台，它基于互联网+肾病的区域大数据采集开放平台，各医疗机构均可加入平台共享数据。可以自动采集医院内部的电子病历、LIS、HIS和PACS等系统中，与肾疾病相关的数据，以便医生积累患者样本数据用于科研和教学。此系统目前在全省推广应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：</span><br/>" + 
          "1）肾病患者的数据自动上传到系统并进行集中化管理<br/>" + 
          "2）实时掌握肾病患者的各项数据情况<br/>" + 
          "3）科研平台数据的搭建，从而进行智能数据分析和数据挖掘<br/>" + 
          "4）各医院之间肾病患者的数据共享，充分利用健康大数据服务于患者<br/>" + 
          "5）支持移动智能终端设备实时访问<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" + 
          "1) 基础数据管理：对系统平台的组织结构和多中心的划分提供数据支持。<br/>" + 
          "2) 病例管理：将患者的信息按照基本信息、诊断、病史特点、体格检查、实验室检查、B超、SPECT-GFR、肾穿刺、肾穿刺病理活检、治疗、随访等部分进行细化管理。<br/>" + 
          "3) 用户管理：涉及到多个权限的用户，包含不同中心和医院，还区分不同岗位，如数据录入员，管理员、审核人员等权限设置。<br/>" + 
          "4）统计分析：对患者的数据进行统计分析。<br/>"
        },
        {
          icon: snzk,
          title: "云南省临床室内检验质量控制平台",
          url: 'http://111.229.189.175:7077/bme-qc',
          // name: "snzk",
          desc: "<span style='font-weight: 700;'>简介：</span>患者在各医院的化验检测结果得不到互相承认，导致重复检查耗费时间和财力。云南省临床室内质控平台系统是全省各医院临床实验室检验质量管理体系的一个重要平台。各地州医院加入此平台就可以监控实验室常规检查工作的准确程度，提高本地区实验室检测中批内、批间样本检测的一致性，以保证实验结果的可靠性。各级医院将检测结果通过接口自动上传到质控平台，就可以对数据进行分析统计，提高医院实验室的质量管理能力和检验人员业务能力，推进检验结果互认工作，从而建立省临床实验室三级质量管理网络体系，缓解“看病难，看病贵”问题。此系统目前在全省推广应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：</span>数据自动上传到平台、及时掌握各医院质控情况，智能数据分析、支持智能移动设备实时访问。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 基础数据：基础数据模块管理分为基础数据和质控数据。主要对系统平台的字典数据进行维护，包含质控流程所需要的支撑数据。<br/>" +
          "2) 质控管理：是整个质控工作的核心模块，包含全部流程和数据分析。<br/>" +
          "3) 知识库管理：是整个质控工作中失控环节的模块，对失控记录进行处理。<br/>" +
          "4) 用户管理：质控系统涉及到了多个权限的用户，包含不同医院和部门，还区分不同岗位，如数据录入员，管理员、审核人员等权限设置。"
        },
        {
          icon: sbgl,
          title: "医疗设备管理系统",
          url: 'http://111.229.189.175:7077/MDMS',
          // name: "sbgl",
          desc: "<span style='font-weight: 700;'>简介：</span>医院的设备种类繁多，招标、采购、使用、维护、巡检和盘点等工作复杂繁重。我们根据医院的实际情况设计并研发了具有通用特性的医疗设备管理系统。它可以对医疗设备生命周期进行全程管理。能够充分体现计划与控制结合、供应与管理结合、消耗与效益结合，使医院设备科管理工作始终集中统一，按计划、按步骤、按规律、按标准有条不紊地进行，便于更好的发挥管理职能，提高设备管理工作的效率和效果。此系统已在实际中应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：<br/></span>" + 
          "1）符合最新《医疗器械使用质量监督管理办法》规定，精细化管理贯穿设备全生命周期<br/>" + 
          "2）实现全院设备尤其是中大型医疗设备精细管理，对工作量化统计更加精准<br/>" + 
          "3）对供货商设备质量、服务，为下次采购设备提供依据<br/>" + 
          "4）医院设备科单机效益更加可视化，助力医院领导轻松决策<br/>" + 
          "5）设备资产建立条码、卡片管理等准确数据记录，管理效率明显提高<br/>" + 
          "6）无线射频（RFID）高效盘点，告别手工盘点<br/>" + 
          "7）医疗设备质控更加严格，设备巡检、维修和计量等工作，系统自动提醒<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 设备申购管理：设备申购管理包括年度计划、采购申请、自定义多级审批权限、供应商询价谈判、招标、供应商合同管理、审计、档案管理、采购验收、科室领用等。<br/>" +
          "2) 资产管理：建立电子台账，确保资产账物相符。包括资产卡片建立、条码扫描、分户电子帐、资产转移、资产报废、资产外调、资产折旧、公用设备租借、资产查询、资产盘点处理等。<br/>" +
          "3) 设备巡检维护维修管理：对设备进行预防性维护，包括保养计划制定、保养计划实施、工作提醒及费用；同时，包括科室报修、维修处理、验收、维修费用统计、工作量统计、维修故障统计、故障报修、维修任务指派、查看维修历史、维修细节记录、更换配件请领、验收结果、维修情况评价、维修费用统计、工作量统计、维修材料消耗统计、维修故障统计等并生成维修报告。<br/>" +
          "4) 计量管理：包括计量设备基本信息录入和计量器具检定信息登记与查询。包括：是否强检、检定单位、检定日期、检定周期、检定证书号、检定效期等。实现对计量器具分布、分类的查询，并明确每一台计量设备的计量检定情况，当检定效期快结束时，系统会给出检定提示。这些功能有效地完成计量设备的管理工作，促进医院计量设备的规范化、严格性管理。"
        },
        {
          icon: hcgl,
          title: "常规医用耗材管理系统",
          url: 'http://111.229.189.175:7077/HSMS',
          // name: "hcgl",
          desc: "<span style='font-weight: 700;'>简介：</span>在医院的诊疗活动中，耗材的使用量极大且名目繁多价值不一，其管理难度很大。常规医疗耗材的品种、规格以及使用量不断增加、细化，对其管理的规范化和精修化越来越重要。我们从实际出发设计并实现了常规医用耗材管理系统。它从根本上解决了流量大、供应商多杂乱、仓库管理复杂等管理困难。此系统已在实际中应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：<br/></span>" + 
          "1）耗材管理精细化细分清楚<br/>" + 
          "2）建立有效的供应商管理系统<br/>" + 
          "3）采购下单极为快速、简便<br/>" + 
          "4）对科室耗材不合理使用进行有效监控<br/>" + 
          "5）对库存预警起到一个及时有效的管理，不会出现证照更换不及时情况<br/>" + 
          "6）耗材库存得到有效控制，不会对耗材产生浪费及杜绝耗材不足的情况<br/>" + 
          "7）实现医院耗材高效审批，盘点更加有高效<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 耗材档案管理：基础档案管理、价格管理、供应商“三证”管理。<br/>" +
          "2) 科室申领：科室库存查询、科室申请、科室领用。<br/>" +
          "3) 采购计划制定：手工制定计划、自动汇总科室申请、库存上下限自动订货<br/>" +
          "4) 采购验收：验收入库、供货商供货查询、应付款查询。<br/>" +
          "5) 科室领用：科室领用、科室使用、各科室领用记录。<br/>" +
          "6) 支持多级审批：可以根据医院实际情况自定义科室领用等审批流程，支持多级审批流程，全程实现电子签名审批。<br/>" +
          "7) 库存管理：多级仓库库存管理、科室库存管理，支持随时查阅仓库存，记录科室耗材的日常使用记录，实时监控各科室的实际用量、库存量及相关数据统计。<br/>" +
          "8) 工作提醒平台：库存预警、有效期预警、证件到期提醒、换证。"
        },
        {
          icon: zcpd,
          title: '固定资产盘点系统',
          url: 'http://111.229.189.175:7073',
          desc: "<span style='font-weight: 700;'>简介：</span>医院的设备数量巨大并且分布在不同的临床科室，每年的设备盘点工作需要精度定位到每一台设备的位置和了解其工作状况，是非常耗时费力的。为此，我们设计和开发了符合临床实际的一套无线盘点系统。盘点工作人员不需要接触设备，在3-5米的距离范围内就可以自动识别设备的位置和采集设备的信息，并自动传送到设备管理系统中，大大提高了工作效率和盘点的准确性。此系统已在实际中应用。<br/>" + 
          "<span style='font-weight: 700;'>特性：</span>简单灵活的RFID高效盘点，全自动化盘点操作。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span>无线射频盘点管理主要包括RFID标签管理、资产盘点、盘点汇总表、盘点数据备份，盘点数据恢复等功能，资产盘点时管理人员利用手持管理设备RFID进行资产的盘点，通过计算机网络，把资产信息直接传到后台数据库；系统维护主要包括人员、角色、权限的维护还包括RFID标签管理，RFID标签管理与资产关联管理，系统维护模块可以管理人员进行维护，并分配人员对应的角色和权限。<br/>"
        },
        {
          icon: ydcx,
          title: "基于移动客户端的查询系统",
          name: "ydcx",
          desc: "<span style='font-weight: 700;'>简介：</span>医院的管理工作者需要随时随地了解医院各部门的运转状况以便做出决策。为此，我们设计并开发了基于移动端的信息查询系统，它可以满足医院管理者对各项管理指标的实时查询需求。可以随时随地利用手机或其它智能设备连接网络查询信息。<br/>" + 
          "<span style='font-weight: 700;'>特性：</span>方便灵活、随时查询，汇总数据分析支持管理决策。另外，可以根据需求扩展查询内容。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 科室信息查询：科室一段时间内基本信息的查询，包括：出院总人数、总药费、总住院费，以及省市医保所占比例的统计等。<br/>" +
          "2) 出院患者信息查询：查询某个时间段内出院病人的基本信息，包括：住院号、姓名、出院日期、总药费、总住院费、总药比等信息。<br/>" +
          "3) 在院患者信息查询：了解目前在院患者的基本信息，包括：住院号、姓名、床号、管理医生、主要诊断、总费用、药费、预交金等信息。<br/>" +
          "4) 科室在院病人发生费用统计：实时查询到目前某个科室在院病人所发生的费用，包括：化验费、放射费、输血费、手术费、西药费等相关费用的合计。<br/>" +
          "5) 科室门诊信息统计：通过以图标和表格的方式对科室门诊的挂号量和挂号费按主任、副主任和普通号进行实时统计。<br/>" +
          "6) 病房医疗工作指标统计报表：截止到某天医院的原有住院人数、入院人数、转入人数、死亡率、实有病床数、床位使用率、出院者平均住院日等相关信息。"
        },
        // {
        //   icon: pacs,
        //   title: "PACS",
        //   name: "pacs",
        //   desc: "<span style='font-weight: 700;'>简介：</span>图像存储与传输系统(Picture Archiving and Communication System, PACS)是专门为医学图像管理而设计的包括图像存储、检索、传输、显示、处理和打印的硬件和软件系统。其目标是为了有效地管理和利用医学图像资源。<br/>" 
        // },
        {
          icon: pacs,
          title: "医学图像处理与分析系统",
          url: '',
          desc: "<span style='font-weight: 700;'>简介：</span>数字医学影像成为医院诊断、治疗方案制定和预后判断的主要手段。我们研发了能处理不同医学影像模态的系统 ImageView，它适配 CT、MRI、超声等多类型医学影像，集成影像存储、检索、传输、显示、测量、处理分析、打印及 AI 临床辅助诊断、疾病筛查等全流程功能，可覆盖临床影像管理、诊断辅助的核心场景，助力提升医院影像处理效率与诊断精准度。<br>" + 
          "<span style='font-weight: 700;'>特性：</span>多模态影像兼容 ； AI 赋能临床辅助；  跨场景高效协作； 精准化操作工具；<br>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br>" + 
          "1) 影像基础管理：实现多模态医学影像的标准化存储，并与患者病历信息关联，构建结构化的影像档案，确保数据的可追溯性，影像检索及影像传输等功能；<br>" + 
          "2) 影像查看与操作：影像显示、测量、标注等功能，满足不同影像观察需求；<br>" + 
          "3) 影像处理与分析：提供滤波、降噪、增强等基础图像处理功能，优化影像视觉效果，提升异常区域辨识度；<br>" + 
          "4) AI 辅助诊断，通过 AI 算法辅助识别影像中的异常征象，输出疑似病变提示，辅助医护人员提升诊断效率；针对特定疾病（如肺结节、骨折等）提供 AI 筛查能力，助力早期风险识别；<br>" + 
          "5) 影像输出：影像打印，支持符合临床规范的影像胶片、报告打印，可按需选择影像区域、搭配诊断信息输出。"
        },
        {
          icon: wd,
          title: "培养箱温度湿度监测系统",
          url: "http://111.229.189.175:7081",
          desc: "<span style='font-weight: 700;'>简介：</span>医院临床科室的很多温控设备需要保持在一定的温度范围内。传统方法靠人定时去检测查看费时费力。我们设计并实现了可以实时监控医院各部门医疗设备的温度和湿度，报警，显示和进行统计分析理。此系统已在实际中应用。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 设备管理：第一个是对采集器管理，新增修改采集器，设置使用中采集器的各项参数，例如温湿度上下限值；第二个是对培养箱、医用冰箱管理，主要是将采集器与对培养箱、医用冰进行关联，设置基础数据。 <br/>" +
          "2) 历史数据：查询及检测设备温湿度信息，并对设备温湿度进行统计分析。<br/>" +
          "3) 系统管理：包括用户信息管理、角色信息管理、用户角色管理；涉及到多个权限的用户，对操作系统的个人和加入系统的单位定义权限和角色限设置。" 
        },
        {
          icon: sjjh,
          title: "医疗数据采集与处理平台",
          url: "http://111.229.189.175:7070",
          desc: "<span style='font-weight: 700;'>简介：</span>医院患者的各种数据信息一般分别存储在各自厂家的系统中，如HIS、LIS、EHRs、PACS等。临床医生采集患者数据需要对接每一个系统，很是繁琐。为此，针对医院各科室数据的采集需求，我们设计并开发了数据采集与分析处理平台，提供了与各厂家医疗系统的数据接口和数据处理，并与各临床科室业务系统进行对接管理。平台可以实现数据库与数据库之间数据交互处理，将从不同的源数据库中提取相应字段，组建数据仓库或目标数据库，并将采集到的源数据进行清洗，并进行逻辑推理判断后存储到数据仓库或目标数据库中，达到便捷高效地采集存储数据，降低了数据采集难度实现数据库资源共享，为建立大数据科研平台奠定基础。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 第三方数据库：主要是对源数据库和目的数据等进行管理，还可以通过模板快速创建资源数据表，还可进行同构数据库；还可以设置数据备份的任务。<br/>" +
          "2) 平台管理：平台管理模块是数据采集处理系统的核心模块，由11个子模块组成。分别为：平台初始化、数据库管理、表与字段别名设置、创建同步任务、创建分发任务、图像信息采集、数据清洗处理、任务状态监控、实时流量监控、配置部分与恢复。<br/>" +
          "3) 数据采集：可实时监控运行中的任务数量及数据缓存情况。<br/>" +
          "4) 平台数据分析：有新的临床业务需求时，可以直接在系统上勾选需求字段，将自动快速生成对应的表。还可以根据用户设置的分析任务，对数据进行分析统计。<br/>" +
          "5) 平台系统管理：涉及到多个权限的用户，对操作系统的个人和加入系统的单位定义权限和角色限设置。"
        },
        {
          icon: sbwx,
          title: "固定资产维修闭环管理系统",
          url: "http://111.229.189.175:7075",
          desc: "<span style='font-weight: 700;'>简介：</span>我们基于移动端设计并开发了医院科室设备的在线报修系统，各临床科室设备相关人员可以在线查看维修进度，在线通过图片、文字、视频、语音来记录维修过程，故障记录；设备科工程师巡检、维护、跟踪记录等作。此系统已在实际中应用。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span>固定资产维修闭环管理系统主要包括设备信息管理、报废设备管理、设备类别管理，维护设备维修记录、报废记录及值班安排和维修转接原因等功能；医院的工作人员对出问题的设备在线进行报修，报修后工程师将会及时收到维修任务，及时进行维修，在特殊情况的时候可以转接维修的任务；在报修和维修的时候可以用文字、图片、语音、视频来描述问题或记录过程，收集的维修记录可作为参考资料；维修人员和报修人员可以随时在线查看维修进度并进行更进。系统维护主要包括人员、角色、权限的维护还包括科室管理，系统维护模块可以管理人员进行维护，并分配人员对应的角色和权限。<br/>"
        },
        {
          icon: xmsb,
          title: "教学质量工程项目申报系统",
          url: "http://111.229.189.175:7079",
          desc: "<span style='font-weight: 700;'>简介：</span>是将学校的科研项目申报过程数字化，让科研项目在线申报审批，减少科研项目申报等待时间；教学质量与教学改革工程项目主要有三大阶段，分别为项目申报阶段、项目建设阶段、项目结题阶段；每个阶段都有申报审批流程，审批时可以使用在线签名，所有审批都通后，可以将项目申报书打印出来归档。简化项目申报流程，提高工作效率，节约时间成本。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span>系统主要划分为三大模块，分别为系统管理、基础信息及教学改革研究与实践项目；系统管理：包括用户管理、角色信息管理、用户角色管理；涉及到多个权限的用户，对操作系统的个人和加入系统的单位定义权限和角色限设置。基础信息是对学校结构及教师工作简历进行管理。教学改革研究与实践项目是系统的核心模块，主要是对科研项目申报、项目建设、项目延期及项目结题进行申报和审批。<br/>"
        },
        {
          icon: xy,
          title: "智慧校园管理系统",
          url: "http://111.229.189.175:7080",
          desc: "<span style='font-weight: 700;'>简介：</span>智慧校园管理系统是一款方便家校联系，方便老师日常工作的一款优秀的软件。该软件极大程度的利用了互联网的优势，拉近了学生、家长、老师和学校之间的距离，担负起了家校沟通合作的重任。方便家长关注学生在校期间的学习生活，能实时记录学生进出学校的考勤状态。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 考试管理：主要是建立试题库，老师可以在线出试题、在线组卷及系统自动改卷和人工改卷相结合，极大的减轻教师的工作量。<br/>" +
          "2) 校园管理：主要是对学生信息、教师信息、班级信息、学校信息、学校食谱、及考勤设置等基本信息进行管理，建设系统基础数据。<br/>" +
          "3) 考勤管理：对考勤机及考勤信息进行管理，还可统计分析学生考勤信息。<br/>" +
          "4) 教务管理：是建立在校园管理模块的基础上，对学校的授课科目及授课课程进行安排管理，与课程相关的内容进行设置或管理，如对作业、成绩及课程表的管理等。<br/>" +
          "5) 学习资源：可以在线上传视频课程，为家长及学生提供更多的学习资源。<br/>" + 
          "6) 问卷管理：设置问卷库及问卷内容，以便学校做问卷调查，对学校的学习环境、安全情况等进行改善提供建议等。"
        },
        {
          icon: hy,
          title: "会议管理系统",
          url: "http://111.229.189.175:7072/admin",
          desc: "<span style='font-weight: 700;'>简介：</span>主要是在学校使用，使用的对象为教师，在线发布会议内容，在发布会议的时候吧，可以定位会议地址、在线安排会议座位即在线排座，当发布完成后，会及时通过手机微信将会议时间地点等内容及时推送给相关人员；还可以在线请假、在线签到，统计会议参会人员情况，极大的提高了人事管理工作。<br/>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br/>" +
          "1) 员工资料：管理学校教职工，或者将教职工设置为系统的用户，建立基础数据。<br/>" +
          "2) 会议管理：包括会议基础信息、会议管理、会议统计、座位预设、员工分组、 请假管理、委托记录等。<br/>" +
          "3) 系统管理：包括用户管理、角色信息管理、用户角色管理；涉及到多个权限的用户，对操作系统的个人和加入系统的单位定义权限和角色限设置。<br/>"
        },
        {
          icon: ds,
          title: "双导师沟通管理系统",
          url: "http://111.229.189.175:7077/DTSMS",
          desc: "<span style='font-weight: 700;'>简介：</span>双导师教学是人才培养模式的一种创新。一个在校学生同时有两位导师进行指导，根据两位导师在教学过程中明确的职责及实现的任务目标对学生进行教学。本系统旨在对双导师模式进行信息化，让双导师与每一个学生的教育互动可记录、追溯和分析统计，提升学生的培养质量。"
        },
        {
          icon: yc,
          title: "育才五会千分修炼系统",
          url: 'http://111.229.189.175:7077',
          desc: "<span style='font-weight: 700;'>简介：</span>育才五会1000分修炼系统软件是以“会做人、会学习、会生存、会关心、会创新”为主要内涵、以实践为准则、以“1000分修炼”为评价基准的立德树人育学新模式。该系统是基于云南育才集团提出五会千分修炼的需求基础上，利用网络平台作为媒介，以学生、家长、老师作为主要使用人群，而开发的B/S模式的网络系统软件。本着贯彻落实“以人为本”的方针，将中小学的“素质教育”全面推展开来，加强和改善学生思想道德教育，创新和改善学生评价机制，促进学生自主成长、全面发展，提高学校教育效果。<br/>"
        },
        {
          icon: gjyl,
          title: "国际医疗服务数字化平台",
          url: "",
          desc: "<span style='font-weight: 700;'>简介：</span>国际医疗服务数字化平台是一套面向跨国医疗服务场景的全流程数字化管理系统，旨在打通境外患者与中国优质医疗资源的对接通道，让来华就医流程更便捷。平台整合云南省特色优质专科医疗服务信息，构建 “患者端 - 医生端” 双向协同体系，覆盖患者从就诊申请、信息查询到治疗跟进，以及医生从申请审批、患者管理到诊疗协作的全流程，助力提升跨境医疗服务效率与体验。<br/>" +
              "<span style='font-weight: 700;'>特性：</span>多语言灵活适配，全流程线上化，个性化智能服务"
        },
        {
          icon: ycyx,
          title: "5G南亚东南亚跨境医学影像远程诊断平台",
          url: "",
          desc: "<span style='font-weight: 700;'>简介：</span>该平台是基于5G技术搭建覆盖医联体所有医疗机构和境外合作医院的远程多学科诊疗服务中心，核心服务于南亚东南亚地区及医联体覆盖的境内县、镇、村医疗机构，旨在搭建 “医联体 + 境外合作医院” 的远程多学科诊疗服务中心。平台通过整合医学影像资源，提供影像分析、远程会诊、多语言实时翻译、诊断等综合服务，实现跨境及基层医疗资源的高效协同，提升区域内医学影像诊断的便捷性与专业性。<br>" +
          "<span style='font-weight: 700;'>特性：</span>跨境 5G 技术适配； 资源覆盖全域化 ；多语言交互支持； 多模态影像精准协同； 数据体系化管理  "
        },
        {
          icon: xljk,
          title: "心理健康测评系统",
          url: '',
          desc: "<span style='font-weight: 700;'>简介：</span>心理健康测评系统是专为院校学生及教职工设计的专业心理管理工具，核心功能包括标准化心理量表测评、个人测评跟踪、群体心理健康数据的统计与可视化分析等，旨在高效助力心理健康筛查及动态管理，具备专业且易用的心理健康管理能力。<br>" + 
          "<span style='font-weight: 700;'>特性：</span>多群体精准覆盖； 数据可视化呈现； 专业量表支撑； 全流程进度追踪  <br>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br>" +
          "1) 用户端功能；专业量表测评，在线完成标准化心理量表，提交后获取个人测评结果；查看自身心理健康数据的趋势图表（如情绪波动曲线），了解个人心理状态的变化情况；<br>" + 
          "2) 管理端功能：统计并展示核心数据，涵盖学生及教职工人数、量表数量、总测试次数等；利用折线图直观呈现学生和教职工人数的年度变化趋势，通过饼图清晰展示测评结果的分布比例；精准聚焦特定群体的心理健康状况；统筹管理测评量表与测试任务，实时跟踪整体测评进度，有效辅助后续心理健康干预工作的顺利开展。"
        },
        {
          icon: zytz,
          title: "中医体质辨识系统与相关特色药食推荐系统",
          url: '',
          desc: "<span style='font-weight: 700;'>简介：</span>该系统是以王琦中医体质九分法为核心依据，构建的 “中医体质辨识 + 特色药食调理” 一体化健康管理平台。它通过体质测试分析用户的中医体质类型，再匹配对应调理的专属药食产品；同时整合体质辨识仪、PC 用户端、手机端等设备，衔接普通用户、体质测试者与医生，实现 “自主测试 - 专业辨识 - 精准调理” 的中医健康管理闭环，助力用户针对性改善体质状态。<br>" + 
          "<span style='font-weight: 700;'>特性：</span>专业体质辨识体系； 体质 - 药食精准适配 ；医养结合服务模式； 多设备多终端协同；<br>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br>" +
          "1)中医体质辨识功能基于王琦中医体质九分法，通过量表测评结合体质辨识仪的生理数据采集，综合分析用户的形态结构、生理功能、心理状态等特征，明确其中医体质类型及当前身体机能状态；<br>" +
          "2)特色药食推荐功能会根据体质辨识结果，匹配对应的专属药食产品，实现针对性的体质调理建议输出；<br>" +
          "3)多终端设备协同功能支持体质辨识仪完成生理数据的专业采集，同时提供 PC 用户管理端、手机端的操作入口，方便用户在不同场景下完成体质测试、查看辨识结果与药食推荐；<br>" +
          "4)用户与专业协作功能普通用户可作为 “体质测试者” 自主完成辨识流程；医生可参与体质测试的专业指导，辅助优化药食调理方案，提升调理的科学性。"
        },
        {
          icon: myjk,
          title: "母婴健康服务系统",
          url: '',
          desc: "<span style='font-weight: 700;'>简介：</span>母婴健康服务系统是聚焦母婴健康服务的专业管理平台，以数据中心为核心衔接用户、医生、服务人员、系统管理人员四类角色，适配手机、电脑等终端，整合产科服务全流程功能，实现母婴健康服务的个性化选择、专业跟进、高效审批与统筹管理，助力提升产科服务的精细化程度与多角色协同效率。<br>" + 
          "<span style='font-weight: 700;'>特性：</span>分角色精准功能匹配；  全流程服务协同<br>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br>" + 
          "1)用户端提供个性化服务套餐选择，用户可根据自身孕产需求，自主挑选适配的产科服务套餐；此外，还设有孕产关爱交流群，用户可加入专属交流群，获取孕产资讯并与同阶段用户互动交流；<br>" + 
          "2)医生端直接对接用户的产科服务需求，全程跟踪用户的服务对接进程；实时掌握所负责用户的服务开展节奏，及时调整服务安排；<br>" + 
          "3)服务人员实时接收系统推送的用户接待相关信息，协同配合开展服务工作。负责处理产科服务相关的报销和退款申请，并高效完成线上审批流程；<br>" + 
          "4)系统管理人员负责提供产科服务项目的管理，维护各类产科服务项目信息，并及时更新服务内容。"
        },
        {
          icon: jhy,
          title: "多功能动态监护仪",
          url: '',
          desc: "<span style='font-weight: 700;'>简介：</span>多功能动态监护仪是医疗监护领域的核心设备，专为实时监测患者生理状态而设计。该设备通过高精度传感器捕捉心电波形、血氧饱和度及血压数据，重点对12导联心电图、血压与心率进行动态监测和记录。它能够替代部分医院目前使用的8导联动态心电设备，采用德州仪器的12导联前端芯片AD51298，实现更丰富的心电信息采集。同时，该设备集成血压测量功能，能够同步完成动态心电与动态血压的实时测量。采集的数据可通过无线网络传输至云端，并配套开发了满足多场景使用需求的应用平台。<br>" + 
          "<span style='font-weight: 700;'>特性：</span>导联升级更全面；高精准数据采集； 多参数集成监测； 云端无线传输；<br>" + 
          "<span style='font-weight: 700;'>功能描述：</span><br>" +
          "1)多生理参数动态监测，全面捕捉患者核心生理状态数据；<br>" +
          "2)可采集更多心电信息，提升心电数据的丰富度；<br>" +
          "3)监测数据通过无线网络实时传输至云端，实现数据的远程存储与集中管理，便于医护人员随时调阅分析；<br>" +
          "4)多场景应用适配，配套开发多场景使用的应用平台，可适配院内临床监护、患者居家动态监测等不同场景的使用需求，提升设备的适用范围。"
        },
      ]
    };
  },
  methods: {
      onClick(item) {
        if (item.name) {
            let href = this.$router.resolve({
            name: item.name
            });
            window.open(href.href, '_blank')
        } else {
            window.open(item.url,"_blank");
        }
      }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/about.less";
</style>
